import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import type { SubTopicDatabase, SubTopicWithLastActivityWithIdDatabase } from '../../../../types';
import { useMergeSubTopics } from '../../api/useMergeSubTopics';

type Props = {
  subTopic: SubTopicDatabase | SubTopicWithLastActivityWithIdDatabase;
  onClose: () => void;
};

export function useMergeSubTopicModal(props: Props) {
  const navigate = useNavigate();
  const spacePath = useSpacePath();
  const { mutateAsync, isPending } = useMergeSubTopics();

  const [targetId, setTargetId] = useState<string | null>(null);
  const [serverError, setServerError] = useState<string | null>(null);

  async function handleConfirm() {
    if (!targetId) {
      setServerError('Choisissez le sous-sujet qui recevra les éléments.');
      return;
    }

    setServerError(null);

    try {
      await mutateAsync({ sourceId: props.subTopic.id, targetId });
      props.onClose();
      navigate(spacePath(`/topics/${targetId}`));
    } catch {
      setServerError('La fusion a échoué. Réessayez dans un instant.');
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return {
    targetId,
    setTargetId,
    serverError,
    isPending,
    handleConfirm,
    handleClose,
  };
}
